export default "__VITE_ASSET__B$y4kIDQ__"